/*
 * @Description: 推荐门店列表
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import viewName from '../constant.js'
import {
    getRecommendStoreList,
} from '@/models/recommendStoreList'
import { wxShare } from '@/utils/wxsdk'

import searchInput from '@/components/searchInput/searchInput'
import storeList from './components/storeList.vue'

export default {
    name: viewName.recommendStoreList,
    components: {
        InfiniteLoading,
        storeList,
        searchInput
    },
    data () {
        return {
            share: {
                desc: '',
                imgUrl: '',
                title: ''
            },
            /* 筛选的过滤参数 */
            params: {
                // is_vip: 0, // 渠道专享
                // distance: 0, // 距离最近排序
                // price: '', // 价格排序
                // tags: '', // 筛选标签id
            },
            position:{
                lng: '',
                lat: ''
            },
            detailParams:{
                distribution_code:''
            },
            tagsData: [], // 标签数据
            list: [],
            page: 1,
            pagesize: 20,
            isload: true,
            text: '', // 搜索名称
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
        ...mapGetters([
            'wxUserInfo'
        ]),
    },
    mounted () {
        this.detailParams = this.$route.query
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    methods: {
        ...mapActions(['setAppClass', 'getWxUserInfo', 'getLocation']),
        /**
         * 获取本地地址
         */
        getMyLocation () {
            return this.getLocation({ timeout: 3000 }).then(this.getPosition)
        },
        /*
         * 获取位置信息并转换为百度坐标系
         */
        getPosition (position) {
            this.position = position
            console.log('获取到的坐标', this.position)
        },
        // /**
        //  * 过滤参数回调
        //  */
        // onFliterParamsCallBack (params, isDefaultParams) {
        //     console.log('onFliterParamsCallBack', params)
        //     this.params = params
        //     if (!isDefaultParams) {
        //         this.getData()
        //     }
        // },
        /**
         * 无限滚动方法
         */
        infinite () {
            this.getList()
        },
        /**
         * 配置微信分享
         * @param {Object} detail
         */
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: detail.title,
                    imgUrl: detail.imgUrl,
                    desc: detail.desc,
                })
            }
        },
        /*
         * 搜索商品
         */
        onSearch (text) {
            this.text = text
            this.getData()
        },
        /**
         * 重置参数并获取数据
         */
        getData () {
            this.page = 1
            this.list = []
            /* 重置会重新请求接口 */
            this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
        },
        /**
         * 获取列表数据
         */
        async getList () {
            const {lat, lng} = this.position
            if (!lat && !lng) {
                await this.getMyLocation().catch((e) => {
                    console.log(e)
                })
            }
            const params = Object.assign({
                text: this.text,
                page: this.page,
                pagesize: this.pagesize,
                lat: this.position.lat,
                lng: this.position.lng,
                distribution_code: this.detailParams.distribution_code
            }, this.params)
            console.log('paramsparams', params)
            try {
                const res = await getRecommendStoreList(params)
                this.list.push(...res.list)
                if (res.list.length < this.pagesize) {
                    this.page = 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (e) {}
        }
    }
}
